export default "__VITE_ASSET__DP7aJLb___"